export const Routes = {
  unauthorized: "/not-allowed",
  authpcke: "/authpcke",
  badges: "/badges",
  createBadge: "/badges/create-badge",
  homepage: "/home",
  main: "/",
  printSettings: "/printerSettings",
  logout: "/logout.html",
  devices: "/devices",
  freya: "/freya",
  start: "/start",
  scanQrCode: "/scanQrCode",
  failed: "/failed",
  success: "/success",
  globalSettings: "/settings",
  company: "/company",
  makePhoto: "/makePhoto",
  goToServiceDesk: "/go-to-service-desk",
  scannedRecently: "/scannedRecently",
  zoneScanningBreakdown: "/zoneScanningBreakdown"
};
